import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";

import ForgetPasswordSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import ecommerceSaga from "./e-commerce/saga";
//import calendarSaga from "./calendar/saga";
import chatSaga from "./chat/saga";
import cryptoSaga from "./crypto/saga";
import invoiceSaga from "./invoices/saga";
import jobsSaga from "./jobs/saga";



import actionSaga from "./actions/saga";
import roleSaga from "./roles/saga";
import accountSaga from "./accounts/saga";
import featureSaga from "./features/saga";
import permissionSaga from "./permissions/saga";
import rolePermissionSaga from "./role-permissions/saga";



import profileSaga from "./profile/saga";
import facultySaga from "./faculties/saga";
import departmentSaga from "./departments/saga";
import serviceSaga from "./services/saga";
import trainingTypeSaga from "./training-types/saga";
import branchSaga from "./branches/saga";
import studyLevelSaga from "./study-levels/saga";
import internshipStructureSaga from "./internship-structures/saga";
import documentTypeSaga from "./document-types/saga";
import courseUnitSaga from "./course-units/saga";
import courseComponentSaga from "./course-components/saga";
import titleSaga from "./titles/saga";
import teacherSaga from "./teachers/saga";
import preRegistrationSaga from "./pre-registrations/saga";
import studentSaga from "./students/saga";
import evaluationSaga from "./evaluations/saga";
import noteSaga from "./notes/saga";
import registrationSaga from "./registrations/saga";
import internshipSaga from "./internships/saga";
import internshipServiceSaga from "./internship-services/saga";
import documentRequestSaga from "./document-requests/saga";
import defenseSaga from "./defenses/saga";
import fileTypeSaga from "./file-types/saga";
import featureFileTypeSaga from "./feature-file-types/saga";
import prestationSaga from "./prestations/saga";
import feeTypeSaga from "./fee-types/saga";
import preRegistrationRejectionSaga from "./pre-registration-rejections/saga";
import semesterSaga from "./semesters/saga";
import academicYearSaga from "./academic-years/saga";
import anonymousExamRecordSaga from "./anonymous-exam-records/saga";
import preRegistrationConfigurationSaga from "./pre-registration-configurations/saga";
import mentionSaga from "./mentions/saga";
import sessionTypeSaga from "./session-types/saga";
import sessionSaga from "./sessions/saga";
import examRoomSaga from "./exam-rooms/saga";
import examRoomAssignmentSaga from "./exam-room-assignments/saga";
import evaluationTypeSaga from "./evaluation-types/saga";
import finalDecisionSaga from "./final-decisions/saga";
import academicCycleConfigSaga from "./academic-cycle-configs/saga";


import projectsSaga from "./projects/saga";
import tasksSaga from "./tasks/saga";
import mailsSaga from "./mails/saga";
import contactsSaga from "./contacts/saga";
import dashboardSaga from "./dashboard/saga";
import dashboardSaasSaga from "./dashboard-saas/saga";
import dashboardCryptoSaga from "./dashboard-crypto/saga";
import dashboardBlogSaga from "./dashboard-blog/saga";
import dashboardJobSaga from "./dashboard-jobs/saga";


export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetPasswordSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),

    //fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(jobsSaga),
    fork(profileSaga),
    
    fork(defenseSaga),
    fork(fileTypeSaga),
    fork(featureFileTypeSaga),
    fork(prestationSaga),
    fork(feeTypeSaga),
    fork(preRegistrationRejectionSaga),
   
    
  
  
  
  
  
    fork(roleSaga),
    fork(accountSaga),
    fork(actionSaga),
    fork(featureSaga),
    fork(permissionSaga),
    fork(rolePermissionSaga),
    fork(facultySaga),
    fork(departmentSaga),
    fork(serviceSaga),
    fork(academicYearSaga),
    fork(anonymousExamRecordSaga),
    fork(preRegistrationConfigurationSaga),
    fork(mentionSaga),
    fork(sessionTypeSaga),
    fork(sessionSaga),
    fork(examRoomSaga),
    fork(examRoomAssignmentSaga),
    fork(evaluationTypeSaga),
    fork(finalDecisionSaga),
    fork(academicCycleConfigSaga),
 
 
    
    fork(trainingTypeSaga),
    fork(branchSaga),
    fork(studyLevelSaga),
    fork(internshipStructureSaga),
    fork(documentTypeSaga),
    fork(courseUnitSaga),
    fork(courseComponentSaga),
    fork(titleSaga),
    fork(teacherSaga),
    fork(preRegistrationSaga),
    fork(studentSaga),
    fork(evaluationSaga),
    fork(noteSaga),
    fork(registrationSaga),
    fork(internshipSaga),
    fork(internshipServiceSaga),
    fork(documentRequestSaga),
    fork(semesterSaga),


    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(dashboardCryptoSaga),
    fork(dashboardBlogSaga),
    fork(dashboardJobSaga)
  ]);
}
